import TablePage from "@beeldit/core/pages/TablePage";
import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import { EditActionProvider } from "@beeldit/core/actions/edit/EditActionContext";

function CustomerPage() {

  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: null,
    filters: null,
    formFilterValues: null,
  }

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <EditActionProvider>
            <TablePage
              {...tablePageParams}
            />
          </EditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default CustomerPage;
